import React, { Component } from 'react';

import CardBox from 'components/CardBox/index';

import TextField from 'components/Core/TextField/index';
import DatePicker from 'components/Core/DatePicker/index';
import Select from 'components/Core/Select/index';
import Checkbox from 'components/Core/Checkbox/index';

import { useForm } from 'util/validatorWithTooltip';

import DataTable from 'components/DataTable/DataTableComponent';
import BaseComponent from 'components/BaseComponent/index';
import IntlMessages from 'util/IntlMessages';

import ClientRequestService from 'services/ClientRequestService';
import AuthUserService from 'services/AuthUserService';

class UserProfile extends Component {
  constructor(props) {
    super(props);

    let authentication = new AuthUserService();
    let user = authentication.getUser();

    this.UserInformation = {
      LogedID: 0,
      UserID: user ? user.UserID : 0,
      UserName: '',
      Name: '',
      ShortName: '',
      Mobile: '',
      Email: '',
      EmployeeID: '',
      DefaultApplicationID: 1,
      CompanyID: '',
      IsAdmin: false,
      IsActive: false,
      InActiveDate: null,

      Password: '',
      ConfirmPassword: ''
    };

    this.state = {
      UserInformation: { ...this.UserInformation },
      keyModel: 'UserInformation',
      keyProp: 'UserID',
      isValidForm: false,
      showSearch: false,
      mountLocalizedComponents: false,
      mountLazyComponents: false,
      buttonPrivileges: {
        showNew: false,
        showCreate: false,
        showUpdate: true,
        showSearch: false,
        showClear: false,
        showDelete: false
      }
    };

    this.SHOMOSHTEEDataHandlerService = new ClientRequestService('SHOMOSHTEE');

    this.baseComponent = React.createRef();
    this.UserGroups = React.createRef();
    this.UserCompanies = React.createRef();
  }

  actionMethods = {
    save: () => {
      this.baseComponent.current.save(
        // this page's ref being sent to base so that we can set its state from there
        this,
        // url: can be passed with or without module, would be `SHOMOSHTEE/Demo/Create` with SHOMOSHTEE module
        'Security/User/CreateUserInfo',
        // module flag: false - module not being passed; true - module being passed
        true,
        // additional model/model list with key to send to server side;
        // pass one or more model/model list with their respective keys
        {
          UserGroups: this.UserGroups.current.state.parentDataSource,
          UserCompanies: this.UserCompanies.current.state.parentDataSource
        },
        // beforSave: receives master model along with other model/model list in case
        // of additional model/model list was/were passed with the help of previous object;
        // you can bind even more model/model list here
        (saveModel) => {
          return saveModel;
        },
        // afterSave: recieves viewModel returned from server; work with those data and other operations
        // that is required to perform i.e. setting grid data filterer or refreshing table data
        (viewModel) => {
          this.UserGroups.current.setDataLoaderParameters({
            [this.state.keyProp]: this.state[this.state.keyModel][this.state.keyProp]
          }).then(() => {
            this.UserGroups.current.refreshTable();
          });

          this.UserCompanies.current.setDataLoaderParameters({
            [this.state.keyProp]: this.state[this.state.keyModel][this.state.keyProp]
          }).then(() => {
            this.UserCompanies.current.refreshTable();
          });
        }
      );
    },
    // same as save
    update: () => {
      this.baseComponent.current.save(
        this,
        'Security/User/UpdateUserInfo',
        true,
        {
          UserGroups: this.UserGroups.current.state.parentDataSource,
          UserCompanies: this.UserCompanies.current.state.parentDataSource
        },
        (saveModel) => {
          saveModel.UserInformation.Password = '';
          saveModel.UserInformation.ConfirmPassword = '';
          return saveModel;
        },
        (viewModel) => {
          this.UserGroups.current.setDataLoaderParameters({
            [this.state.keyProp]: this.state[this.state.keyModel][this.state.keyProp]
          }).then(() => {
            this.UserGroups.current.refreshTable();
          });

          this.UserCompanies.current.setDataLoaderParameters({
            [this.state.keyProp]: this.state[this.state.keyModel][this.state.keyProp]
          }).then(() => {
            this.UserCompanies.current.refreshTable();
          });
        }
      );
    },
    // same as save or update - only difference is that it is assumed no significant
    // data model other than delete success or failure status would be passed from server
    // during delete opetation; therefore afterDelete method is receiving no viewModel parameter
    delete: () => {
      this.baseComponent.current.delete(
        this,
        //'Demo/Delete',
        'Security/User/DeleteUserInfo',
        true,
        {
          UserGroups: this.UserGroups.current.state.parentDataSource,
          UserCompanies: this.UserCompanies.current.state.parentDataSource
        },
        (postData) => {
          return postData;
        },
        () => { }
      );
    },
    new: () => {
      this.baseComponent.current.new(
        // this page's ref being sent to base so that we can set its state from there
        this,
        // beforeNew: perform page specific operations before new
        () => { },
        // afterNew: perform page specific operations after new i.e. clearing grid data
        () => {
          this.UserGroups.current.clearData();
          this.UserCompanies.current.clearData();
        }
      );
    },
    clear: () => {
      this.baseComponent.current.clear(
        // this page's ref being sent to base so that we can set its state from there
        this,
        // beforeClear: perform page specific operations before clear
        () => { },
        // afterClear: perform page specific operations after clear i.e. clearing grid data
        () => {
          this.UserGroups.current.clearData();
          this.UserCompanies.current.clearData();
        }
      );
    }
  };

  componentDidMount() {
    var that = this;

    this.userGroups = {
      layout: {
        editable: false,
        autoLayout: true,
        template: [
          { field: 'SecurityGroupUserChildID', style: { display: 'none' } },
          { field: 'UserID', style: { display: 'none' } },
          {
            field: 'SecurityGroupID', header: 'Group Name', type: 'combo',
            loader: {
              url: 'Security/Combo/GetSecurityGroupComboSource', withModule: true, options: [],
              mapper: { valueMapper: 'value', textMapper: 'text', descMapper: 'desc' }
            },
            onChange: (e, colProps) => {
              let duplicateValues = colProps.value.filter(row => row[colProps.field] === e.target.value);

              if (duplicateValues.length > 0) {
                that.baseComponent.current.openMessageDialog('Duplicate Group', 'Group already tagged!!!');       // show notification message
                return Promise.resolve({ value: colProps.value[colProps.rowIndex][colProps.field], colProps });   // undo change
              }

              colProps.value[colProps.rowIndex]['SecGroupDescription'] = e.target.value ? e.currentTarget.attributes.desc.value : '';
              return Promise.resolve({ value: e.target.value, colProps });
            },
            style: { textAlign: 'left' }, readonly: true
          },
          { field: 'SecGroupDescription', header: 'Group Description', sortable: false, filter: false, editable: false, readonly: true, style: { textAlign: 'left' } }
        ],
        showAdd: false,
        showDelete: false,
        showRefresh: true,
        showRestore: false,
        paginator: true,
        lazy: false,
        onRowAdded: function (rowData) {
          rowData[that.state.keyProp] = that.state[that.state.keyModel][that.state.keyProp]
          return rowData;
        }
      },
      data: {
        controller: 'User',
        dataLoader: 'GetUserGroups',
        extraParameter: { [this.state.keyProp]: 0 }
      }
    }

    this.userCompanies = {
      layout: {
        editable: false,
        autoLayout: true,
        template: [
          { field: 'UserCompanyID', style: { display: 'none' } },
          { field: 'UserID', style: { display: 'none' } },
          {
            field: 'CompanyID', header: 'Company', type: 'combo',
            loader: {
              url: 'Combo/GetCompanies', withModule: false, options: [],
              mapper: { valueMapper: 'CompanyID', textMapper: 'CompanyName' }
            },
            onChange: (e, colProps) => {
              let duplicateValues = colProps.value.filter(row => row[colProps.field] === e.target.value);

              if (duplicateValues.length > 0) {
                that.baseComponent.current.openMessageDialog('Duplicate Company', 'Company already tagged!!!');   // show notification message
                return Promise.resolve({ value: colProps.value[colProps.rowIndex][colProps.field], colProps });   // undo change
              }

              if (e.target.value) {
                //let fetchCompanyInformationTask = that.SHOMOSHTEEDataHandlerService.Get({
                that.SHOMOSHTEEDataHandlerService.Get({
                  url: `Company/Get/${e.target.value}`,
                  withModule: false
                }).then((company) => {
                  if (company) {
                    colProps.value[colProps.rowIndex]['CompanyAddress'] = company.CompanyAddress;
                    that.UserCompanies.current.setState({ parentDataSource: colProps.value });
                  }
                });
              }

              return Promise.resolve({ value: e.target.value, colProps });
              //return Promise.resolve({ value: fetchCompanyInformationTask, colProps });
            },
            style: { textAlign: 'left' }, readonly: true
          },
          { field: 'CompanyAddress', header: 'Address', sortable: false, filter: false, editable: false, readonly: true, style: { textAlign: 'left' } },
          {
            field: 'IsDefault', header: 'Default', type: 'checkbox', sortable: false, filter: false, editable: false, readonly: true,
            onChange: (e, colProps) => {
              if (e.target.checked)  // if checking
              {
                colProps.value.forEach(rowData => rowData['IsDefault'] === true ? rowData['IsDefault'] = false : null);  // uncheck other checked rows
                if (colProps.value[colProps.rowIndex]['CompanyID']) {
                  //that.UserInformation.CompanyID = colProps.value[colProps.rowIndex]['CompanyID'];
                  this.setState({
                    stateToFormData: true,
                    UserInformation: { ...this.state.UserInformation, CompanyID: colProps.value[colProps.rowIndex]['CompanyID'] }
                  });
                }
              }
              else    // if unchecking
              {
                e.target.checked = true; // uncheck canceled
              }

              return Promise.resolve({ checked: e.target.checked, colProps });
            },
            style: { textAlign: 'center' }
          }
        ],
        showAdd: false,
        showDelete: false,
        showRefresh: true,
        showRestore: false,
        paginator: true,
        lazy: false,
        onRowAdded: function (rowData) {
          rowData[that.state.keyProp] = that.state[that.state.keyModel][that.state.keyProp]
          return rowData;
        }
      },
      data: {
        controller: 'User',
        dataLoader: 'GetUserCompanies',
        extraParameter: { [this.state.keyProp]: 0 }
      }
    }

    this.setState({ mountLocalizedComponents: true, loadAtStartUp: true });
    this.baseComponent.current.setModelState(this.state[this.state.keyModel][this.state.keyProp]);
  }

  componentDidUpdate(prevProps, prevStates) {
    if (this.state.loadAtStartUp !== prevStates.loadAtStartUp) {
      this.baseComponent.current.load(this, 'User', `Get/${this.UserInformation.UserID}`, null, null, null, (viewModel) => {
        if (viewModel) {
          this.UserGroups.current.setDataLoaderParameters({
            [this.state.keyProp]: this.state[this.state.keyModel][this.state.keyProp]
          }).then(() => {
            this.UserGroups.current.refreshTable();
          });

          this.UserCompanies.current.setDataLoaderParameters({
            [this.state.keyProp]: this.state[this.state.keyModel][this.state.keyProp]
          }).then(() => {
            this.UserCompanies.current.refreshTable();
          });
        }
      });
    }
  }

  render() {
    return (
      <>
        <div className='app-wrapper'>
          {/* <ContainerHeader match={this.props.match} title={<IntlMessages id='pages.UserInformation' />} /> */}
          <div className='row'>
            <div className='col-lg-6'>
              <FormWithValidation parent={this} />
            </div>
            <div className='col-lg-6'>
              <div className='row'>
                <div className='col-12'>
                  <CardBox heading='Attached Groups' styleName='' cardStyle='' childrenStyle='' headerOutside='' headingStyle='' children={
                    <div>
                      {
                        this.state.mountLocalizedComponents &&
                        <DataTable ref={this.UserGroups} module='Security' tableConfig={this.userGroups.layout} dataSourceConfig={this.userGroups.data} />
                      }
                    </div>
                  } />
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <CardBox heading='Attached Companies' styleName='' cardStyle='' childrenStyle='' headerOutside='' headingStyle='' children={
                    <div>
                      {
                        this.state.mountLocalizedComponents &&
                        <DataTable ref={this.UserCompanies} module='Security' tableConfig={this.userCompanies.layout} dataSourceConfig={this.userCompanies.data} />
                      }
                    </div>
                  } />
                </div>
              </div>
            </div>
          </div>
        </div>

        <BaseComponent module='Security' privileges={{ CanCreate: false, CanRead: true, CanUpdate: true, CanDelete: false }} buttonPrivileges={this.state.buttonPrivileges} parameters={this.props.parameters} actionMethods={{ ...this.actionMethods, search: this.search }} isValidForm={this.state.isValidForm} ref={this.baseComponent} />
      </>
    );
  }
}

const FormWithValidation = ({ parent }) => {
  const { useInput, useDate, useCheckbox } = useForm(
    parent, { ...parent.state.UserInformation, keyProp: parent.state.keyProp }
  );

  return (
    <CardBox
      heading={<IntlMessages id='pages.UserInformation' />}
      styleName='' cardStyle='' childrenStyle='' headerOutside='' headingStyle=''
      children={
        <div className='row'>
          {/* <TextField
            {...useInput('UserID')}
            className='d-none' /> */}
          <div className='col-md-12 col-12 d-none'>
            <TextField
              disabled
              // readonly
              label='User ID'
              {...useInput('UserID', '', '')} />
          </div>
          <div className='col-md-12 col-12'>
            <Select id='employeeCombo' required disabled label='Employee Name' {...useInput('EmployeeID', 'isRequired', 'Employee selection is required!')}
              url='Combo/GetEmployees' withModule={false} options={[]} mapper={{ valueMapper: 'EmployeeID', textMapper: 'EmployeeName' }} />
          </div>
          <div className='col-md-12 col-12'>
            <TextField
              required
              disabled
              label='Name'
              {...useInput('Name', 'isRequired', 'Name is required!')} />
          </div>
          <div className='col-md-12 col-12'>
            <TextField
              required
              label='Short Name'
              {...useInput('ShortName', 'isRequired', 'Short Name is required!')} />
          </div>
          <div className='col-md-12 col-12'>
            <TextField
              required
              disabled // temporary?
              label='User Name'
              {...useInput('UserName', 'isRequired', 'User Name is required!')} />
          </div>
          <div className='col-md-6 col-12 d-none'>
            <TextField
              //required
              type='password'
              autoComplete='new-password'
              label='Password'
              {...useInput('Password', '', '')} />
          </div>
          <div className='col-md-6 col-12 d-none'>
            <TextField
              //required
              type='password'
              label='Confirm Password'
              {...useInput('ConfirmPassword', '', '')} />
          </div>
          <div className='col-md-12 col-12'>
            <TextField
              label='Email'
              required
              {...useInput('Email', 'isEmail', 'Invalid Email!')} />
          </div>
          <div className='col-md-12 col-12'>
            <TextField
              label='Mobile Number'
              {...useInput('Mobile')} />
          </div>
          <div className='col-md-12 col-12 d-none'>
            <Select id='companyCombo' label='Company' {...useInput('CompanyID', 'isRequired', 'Company selection is required!')}
              url='Combo/GetCompanies' withModule={false} options={[]} mapper={{ valueMapper: 'CompanyID', textMapper: 'CompanyName' }} />
          </div>
          {/* <div className='col-md-12 col-12'>
            <Select id='defaultApplicationCombo' label='Default Application' {...useInput('DefaultApplicationID', 'isRequired', 'Default Application selection is required!')}
              url='Combo/GetCompanies' withModule={false} options={[]} mapper={{ valueMapper: 'value', textMapper: 'text' }} />
          </div> */}
          <div className='col-md-4 col-12 d-none'>
            <Checkbox label='Admin User' {...useCheckbox('IsAdmin')} />
          </div>
          <div className='col-md-4 col-12 d-none'>
            <Checkbox label='Active User' {...useCheckbox('IsActive')} />
          </div>
          <div className='col-md-6 col-12 d-none'>
            <DatePicker
              label='Inactive Date'
              {...useDate('InActiveDate', '', '')}
              KeyboardButtonProps={{
                'aria-label': 'Date',
              }} />
          </div>
        </div>
      } />
  );
};

export default UserProfile;
